import * as React from 'react';
import { Theme } from '../../../../../types';
import { FormField, RadioGroup } from 'wix-style-react';
import { DataHooks } from '../../../../../constants/data-hooks';
import { translate, InjectedTranslateProps } from 'react-i18next';

interface Props extends InjectedTranslateProps {
  theme?: Theme;
  onChangeTheme: (value: any) => void;
}

const ThemeEditorComponent = ({ t, theme, onChangeTheme }: Props) => (
  <FormField label={t('text-and-display.theme.title')}>
    <RadioGroup dataHook={DataHooks.TextAndDisplayTheme} value={theme} onChange={onChangeTheme}>
      <RadioGroup.Radio value={Theme.light}>{t('text-and-display.theme.light')}</RadioGroup.Radio>
      <RadioGroup.Radio value={Theme.dark}>{t('text-and-display.theme.dark')}</RadioGroup.Radio>
    </RadioGroup>
  </FormField>
);

export const ThemeEditor = translate()(ThemeEditorComponent);
